import Ores1 from "./ores (1).webp";
import Ores2 from "./ores (2).webp";
import Ores3 from "./ores (3).webp";
import Ores4 from "./ores (4).webp";
import Ores5 from "./ores (5).webp";
import Ores6 from "./ores (6).webp";
import Ores7 from "./ores (7).webp";
import Ores8 from "./ores (8).webp";
import Ores9 from "./ores (9).webp";
import Ores10 from "./ores (10).webp";

const ores = [
  Ores1,
  Ores2,
  Ores3,
  Ores4,
  Ores5,
  Ores6,
  Ores7,
  Ores8,
  Ores9,
  Ores10,
];

export default ores;
